import _ from 'lodash'
import { Card, CardText, CardTitle, Divider } from 'react-md'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { SubmissionError } from 'redux-form'
import { withRouter } from 'react-router-dom'

import { UploadStatus } from 'api/enums'
import { UserStatic } from 'api'
import { USER_ID_PARAM } from 'routes/params'
import {
  getUser,
  getAuthUser,
  getIsFetchingUsers,
  getProfileUpload
} from 'redux/reducers'
import * as actions from 'redux/actions'
import * as routes from 'routes'

import ViewHeader from './ViewHeader'
import ViewContent from './ViewContent'

class View extends Component {
  constructor (props) {
    super(props)
    this.goBack = this.goBack.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleSave = this.handleSave.bind(this)
    this.handleUpload = this.handleUpload.bind(this)
  }

  componentWillMount () {
    const { isAccount } = this.props
    if (!isAccount) {
      const { loadUser, match } = this.props
      const userId = match.params[USER_ID_PARAM]
      loadUser(userId)
    }
  }

  goBack () {
    const { isAccount } = this.props
    if (!isAccount) {
      const { history } = this.props
      history.push(routes.users())
    }
  }

  handleDelete (event) {
    event.preventDefault()
    const { deleteUser, match } = this.props
    const userId = match.params[USER_ID_PARAM]
    deleteUser(userId)
    this.goBack()
  }

  async handleSave (data) {
    const { mergeUser } = this.props
    const response = await mergeUser(data.id, data)
    if (response.errors) {
      throw new SubmissionError(
        _.defaults({ _error: response.message }, response.errors)
      )
    }
    this.goBack()
  }

  async handleUpload (files) {
    const { uploadProfileImage, user } = this.props

    const file = files[0]

    await uploadProfileImage(user.id, file)

    this.forceUpdate()
    this.render()
  }

  render () {
    const { user, isFetchingUsers, profileUpload, isAccount } = this.props

    let profileUrl = null

    if (profileUpload.status !== UploadStatus.UPLOADING) {
      profileUrl = UserStatic.getImageURL(user.id, user.signature)
    }

    const sectionTitle = 'User Account'

    let editPasswordRoute = null

    if (isAccount) {
      editPasswordRoute = routes.accountEditPassword()
    } else {
      const { match } = this.props
      editPasswordRoute = routes.userEditPassword(match.params[USER_ID_PARAM])
    }

    return (
      <div>

        <Card>

          <ViewHeader
            disableGoBack
            disableDelete
            onSubmit={this.handleSave}
          />

          <Divider />

          <CardTitle title={sectionTitle} />

          <CardText>
            { isFetchingUsers && !user.id ? (
              <div>Loading...</div>
            ) : (
              <ViewContent
                initialValues={_.omit(user, ['signature'])}
                editPasswordRoute={editPasswordRoute}
                handleUpload={this.handleUpload}
                uploadStatus={profileUpload}
                profileUrl={profileUrl}
              />
            ) }
          </CardText>

        </Card>

      </div>
    )
  }
}

View.propTypes = {
  user: PropTypes.object.isRequired
}

const mapStateToProps = (state, { match }) => {
  const userId = match.params[USER_ID_PARAM]
  const user = userId ? getUser(state, userId) : getAuthUser(state)
  return {
    user,
    isFetchingUsers: getIsFetchingUsers(state),
    profileUpload: getProfileUpload(state)
  }
}

export default withRouter(connect(mapStateToProps, actions)(View))



// WEBPACK FOOTER //
// ./src/containers/User/View/index.js